// extracted by mini-css-extract-plugin
export default {"infoInput":"styles_infoInput__TvxRc","label":"styles_label__gza8Z","loginBtn":"styles_loginBtn__293OR"};